import { Suspense, useMemo, useCallback, useContext, useState, useEffect } from "react";
import { LazyBrandingActions, LazyCustomFormDialog, LazyPlanBranding } from "../../../../../../shared";
import { Paper } from "@mui/material";
import { AccidentBanner, HIBanner, KemperBanner } from "../../../../../../../assets";
import { useLocation, useHistory } from "react-router-dom";
import PlanHeader from "../../../../../../shared/enrollment/planCode/PlanHeader";
import { VEBBrandingProps } from "../../../../../../../types/components/enrollmentProps.types";
import { AuthContext } from "../../../../../../../contexts";
import { CustomFormDialogType } from "../../../../../../../types/components/dialogProps.types";
import { VEBPlan } from "../../../../../../../types/plan.types";
import { generateCancerKemperWaiveEnrollmentPayload } from "../../../../../../../utils/commonFunctions/VEBEnrollment/enrollment";
import { VEB_PLAN_NAME, VEB_PLAN_NAMES } from "../../../../../../../constants/plan";
import { GetBenefitsQuery, VEBEnrollmentPayload } from "../../../../../../../utils/api/enrollment/enrollment";
import { api } from "../../../../../../../utils/api";
import { dateTimeZoneConverter, getFirstOfNextMonth } from "../../../../../../../utils/commonFunctions/date";
import VEBPlanHeader from "../../../../../../shared/enrollment/VEBPlanHeader/PlanHeader";
import { trackPromise } from "react-promise-tracker";
import { useEmployeeVEBEligiblity } from "../../../../../../../hooks";
import VEBPreviousBenefitDisclaimer from "../../../../../../shared/VEBPreviousBenefitDisclaimer/VEBPreviousBenefitDisclaimer";
import { CheckPreviousVEBEnrollmentQueryTypes } from "../../../../../../../utils/api/enrollment/getCheckPreviousVEBEnrollment";
import { BenefitGrid } from "../../../../../../../types/enrollmentV2.types";
import VEBPreviousBenefitDisclaimerV2 from "../../../../../../shared/VEBPreviousBenefitDisclaimer/VEBPreviousBenefitDisclaimerV2";
import { VEBYearlyOpenAndCurrentEffectiveDate } from "../../../../../../../constants/VEBYearlyOpenAndCurrentDate";

const KemperHospitalIndemnityBranding = ({
	VEBOpenEnrollment,
	dependents,
	status,
	getVEBEnrollmentInitData
}: VEBBrandingProps) => {
	const { isEligible, eligiblityMessage } = useEmployeeVEBEligiblity("Hospital Indemnity");
	const [waiveReason, setWaiveReason] = useState("");
	const { member } = useContext(AuthContext);
	const location = useLocation();
	const history = useHistory();
	const [planCode, setPlanCode] = useState<string>();
	const [VEBOpenEnrollmentId, setVEBOpenEnrollmentId] = useState<string>();
	const [vebBenefits, setVebBenefits] = useState<BenefitGrid[]>([]);
	const [hospitalIndemnityPlan, setHospitalIndemnityPlan] = useState<VEBPlan>({
		_id: "",
		plan_name: "",
		plan_code: "",
		start_date: null,
		end_date: null,
		status: ""
	});
	const [customFormDialogProps, setCustomFormDialogProps] = useState<CustomFormDialogType>();
	const [hasPreviousVEBEnrollment, setHasPreviousVEBEnrollment] = useState<boolean>(false);

	const getCheckPreviousVEBEnrollment2023 = useCallback(async (group_number, SSN) => {
		const checkPreviousPayload: CheckPreviousVEBEnrollmentQueryTypes = {
			group_number,
			insured_SSN: SSN
		};

		const response = await trackPromise(api.enrollment.getCheckPreviousVEBEnrollment(checkPreviousPayload));

		if (response) {
			for (let idx = 0; idx < response.length; idx++) {
				const eachPlan = response[idx];

				if (eachPlan.plan_name === VEB_PLAN_NAMES.hospital_indemnity) {
					setHasPreviousVEBEnrollment(true);
				}
			}
		}
	}, []);

	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);

	const handleWaiveReasonChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;
		setWaiveReason(value);
	};

	const getVEBPlanCode = useCallback((VEBOpenEnrollment: any[]) => {
		// // console.log("**********VEBOpenEnrollment********", VEBOpenEnrollment[0]);
		let _planCode, _VEBOpenEnrollmentId;
		for (let idx = 0; idx < VEBOpenEnrollment.length; idx++) {
			const planName = VEBOpenEnrollment[idx].open_enrollment.veb_plan_name;
			const planCode = VEBOpenEnrollment[idx].open_enrollment.veb_plan_code;
			const VEBPlanId = VEBOpenEnrollment[idx].open_enrollment.veb_plan_id;
			const VEBOpenEnrollmentId = VEBOpenEnrollment[idx].VEB_open_enrollment_id;
			// // console.log("<====Plan Name===>", planName);

			if (planName === VEB_PLAN_NAMES.hospital_indemnity) {
				_planCode = planCode;
				_VEBOpenEnrollmentId = VEBOpenEnrollmentId;

				const _planPaylaod = {
					_id: VEBPlanId,
					plan_name: planName,
					plan_code: _planCode,
					start_date: null,
					end_date: null,
					status: "ACTIVE"
				};

				setHospitalIndemnityPlan(Object.assign({}, _planPaylaod));
			}
		}

		setPlanCode(_planCode);
		setVEBOpenEnrollmentId(_VEBOpenEnrollmentId);
	}, []);

	const handleEnrollButtonClick = useCallback(() => {
		if (isEligible === false) {
			alert(eligiblityMessage);
			return;
		}
		// console.log("openEnrollment", VEBOpenEnrollment);
		if (VEBOpenEnrollment && VEBOpenEnrollment.length > 0) {
			const step = urlSearchParams.get("step");
			history.push(`?step=${step}&stage=1`);
		} else {
			alert("Enrollment has not been opened for this plan. Please contact your administrator");
		}
	}, [isEligible, VEBOpenEnrollment, eligiblityMessage, urlSearchParams, history]);

	const handleWaiveEnrollment = useCallback(async () => {
		if (member === null || VEBOpenEnrollment === null) {
			return;
		}
		const { VEBEnrollmentCommonDetails, VEBEnrollmentStandardDetails } = generateCancerKemperWaiveEnrollmentPayload(
			hospitalIndemnityPlan,
			VEB_PLAN_NAME.kemper.hospital.standard_hospital,
			VEB_PLAN_NAME.kemper.hospital.standard_hospital,
			null,
			null,
			member,
			waiveReason,
			VEBOpenEnrollmentId as unknown as string,
			false
		);
		const VEBEnrollmentPayload: VEBEnrollmentPayload = {
			standard_details: VEBEnrollmentStandardDetails,
			common_details: VEBEnrollmentCommonDetails,
			isRider: false
		};
		const response = await trackPromise(api.enrollment.addVEBEnrollment(VEBEnrollmentPayload));
		// console.log("response", response);
		getVEBEnrollmentInitData();
	}, [member, VEBOpenEnrollment, hospitalIndemnityPlan, waiveReason, VEBOpenEnrollmentId, getVEBEnrollmentInitData]);

	const handleWaiveButtonClick = useCallback(() => {
		if (isEligible === false) {
			alert(eligiblityMessage);
			return;
		}
		setCustomFormDialogProps(
			Object.assign({}, customFormDialogProps, {
				openDialog: true,
				title: "Are you sure want to waive this enrollment?",
				textfields: [
					{
						label: "Waive Reason",
						onChange: handleWaiveReasonChange,
						value: waiveReason,
						placeholder: "Enter your reason for waive"
					}
				],
				actions: [
					{
						label: "Cancel",
						callback: () =>
							setCustomFormDialogProps(Object.assign({}, customFormDialogProps, { openDialog: false }))
					},
					{
						label: "Yes",
						callback: () => {
							setCustomFormDialogProps(
								Object.assign({}, customFormDialogProps, {
									openDialog: false
								})
							);
							handleWaiveEnrollment();
						}
					}
				]
			})
		);
	}, [customFormDialogProps, eligiblityMessage, handleWaiveEnrollment, isEligible, waiveReason]);

	useEffect(() => {
		if (VEBOpenEnrollment && VEBOpenEnrollment.length !== 0) {
			getVEBPlanCode(VEBOpenEnrollment);
		}
	}, [VEBOpenEnrollment, getVEBPlanCode]);

	useEffect(() => {
		if (member) getCheckPreviousVEBEnrollment2023(member.group_number, member.SSN);
	}, [getCheckPreviousVEBEnrollment2023, member]);

	return (
		<div className="paper-form-container">
			<Suspense fallback={<div />}>
				{customFormDialogProps ? <LazyCustomFormDialog customFormDialogProps={customFormDialogProps} /> : null}
			</Suspense>
			<Paper className="theme-border-radius paper-container" elevation={1}>
				<VEBPlanHeader
					planName="MedMutual Protect Group Hospital Indemnity Insurance Policy"
					effectiveDate={
						planCode
							? planCode === "HI-ALL-2024"
								? VEBYearlyOpenAndCurrentEffectiveDate.veb_current_effective_date_MMDDYYYY
								: VEBYearlyOpenAndCurrentEffectiveDate.veb_yearly_open_effective_date_MMDDYYYY
							: "N/A"
					}
					planCode={planCode ? (planCode as unknown as string) : "No Plan is Opened"}
				/>
				<div className="theme-plan-section-margin" />
				<LazyPlanBranding imgSrc={HIBanner} />
				{/* Disclaimer for VEB Plans, if 2023 Cancer is enrolled */}
				{/* {hasPreviousVEBEnrollment ? <VEBPreviousBenefitDisclaimer /> : null} */}
				{hasPreviousVEBEnrollment ? <VEBPreviousBenefitDisclaimerV2 /> : null}
				<Suspense fallback={<div />}>
					<LazyBrandingActions
						waiveButtonCallback={handleWaiveButtonClick}
						enrollButtonCallback={handleEnrollButtonClick}
					/>
				</Suspense>
			</Paper>
		</div>
	);
};

export default KemperHospitalIndemnityBranding;
